exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2ODFvHl3MvT2_r7dB29cpe {\n  display: flex;\n  height: 100%;\n  align-items: center;\n  flex-direction: column;\n  justify-content: space-between;\n  flex: 1;\n  padding-top: 20%;\n}\n._2ODFvHl3MvT2_r7dB29cpe p {\n  margin-bottom: 1rem !important;\n}\n@media (max-height: 600px) {\n  ._2ODFvHl3MvT2_r7dB29cpe {\n    padding-top: 10%;\n  }\n}\n._2tyXZO5tKXckEe9UmocGIX {\n  margin-top: 2rem;\n  line-height: 0!important;\n  font-size: 0!important;\n}\n", ""]);

// exports
exports.locals = {
	"container": "_2ODFvHl3MvT2_r7dB29cpe",
	"statusMessage": "_2tyXZO5tKXckEe9UmocGIX"
};